<div
	class="freya-event-container"
	[ngClass]="{
       'freya-event-hidden': hidden,
       'freya-event-edited': hasBeenEdited,
       'freya-event-draggable': editable,
       'freya-event-disabled': disabled,
       'freya-month-event': isMonthView,
       'show-crew': showCrew && ((crewAttendees?.length || 0) > 0 || (commonCrew?.length || 0) > 0),
       'vertical-view-card': isVerticalView
     }"
>

	<!-- Event Element -->
	<div
		class="freya-calendar-event"
		[ngStyle]="eventStyle"
	>
		<div class="event-main-content">
			<span
				*ngIf="isVerticalView && headerTitle"
				class="asset-names"
			>{{ headerTitle }}</span>
			
            <div class="title-row">
                <i
                    class="pi status-icon-inline"
                    [ngClass]="statusIcon"
                    [style.color]="colors.textColor"
                >
                </i>
                <span
                    *ngIf="showWelcomeCall"
                    class="welcome-call-indicator"
                    title="Welcome call made"
                    [style.backgroundColor]="colors.textColor"
                    [style.color]="colors.backgroundColor"
                >W</span>
                <span class="title info">{{ title }}</span>
            </div>

			<div class="details-row">
                <!-- Labor Time -->
				<span
					*ngIf="totalTime"
					title="Total Time"
                    class="icon-text"
				>
                    <span
                        class="labor-charge-indicator"
                        [style.backgroundColor]="colors.leftDivColor || colors.backgroundColor"
                        [style.border]="'1.5px solid ' + colors.travelTimeColor"
                    >
                    </span>
                    {{ totalTime }}
                </span>

                <!-- Drive Time -->
                <span
					*ngIf="totalDriveTime"
					title="Drive Time"
                    class="icon-text"
				><i
						class="pi pi-car"
						style="font-size: 0.9em"
					></i> {{ totalDriveTime }}</span>

                <!-- Total -->
				<span
					*ngIf="eventTotal"
					title="Event Total"
				>{{ eventTotal }}</span>
			</div>

            <!-- Areas -->
            <div class="areas-row" *ngIf="startPostalCode || endPostalCode">
                <span class="postal info">
                    <span *ngIf="startPostalCode">{{ startPostalCode }}</span>
                    <span *ngIf="endPostalCode"><span *ngIf="startPostalCode"> - </span>{{ endPostalCode }}</span>
                </span>
            </div>

			<!-- Crew Summary Row -->
			<div
				class="crew-summary-row"
				*ngIf="showCrew && crewSummary"
			>
				<i
					class="pi pi-users"
					style="margin-right: 4px; font-size: 0.9em;"
				></i>
				<span [title]="crewSummary">{{ crewSummary }}</span>
			</div>

			<!-- Crew Chips (Extras) -->
			<app-crew-list
				*ngIf="showCrew && isVerticalView"
				[crew]="crewAttendees"
				layout="column"
			></app-crew-list>
		</div>
	</div>

	<!-- Timeline Bar (Combined Travel & Area) -->
	<div
		class="event-timeline-bar"
		*ngIf="!isMonthView && timelineSegments?.length"
		[class.vertical-bar]="isVerticalView"
		[style.marginLeft.px]="isVerticalView ? 0 : null"
	>
		<div
			*ngFor="let segment of timelineSegments"
			[style.width.%]="isVerticalView ? 100 : (segment.width || 0)"
			[style.height.%]="isVerticalView ? (segment.width || 0) : 100"
			[style.backgroundColor]="segment.color"
			[style.opacity]="segment.opacity || 1"
			[title]="segment.title"
			class="timeline-segment"
			style="min-height: 1px;"
		></div>
	</div>
</div>